import bannerImage from "../assets/images/bannerImage/channels4_banner.webp";

const BannerImageContent = () => {
  return (
    //   <div className="flex mb-2  items-center  justify-center mx-3">
    //   <img src={bannerImage} alt="bannerImage" loading="lazy" className="w-full rounded-lg" />
    // </div>

    <div className="flex mb-2 items-center justify-center">
      <img
        src={bannerImage}
        alt="Ceylon Hospital Banner"
        width={1200}
        height={630}
        loading="eager"
        className="w-full  max-w-8xl"
        decoding="async"
        style={{
          height: "auto",
          objectFit: "cover",
        }}
      />
    </div>
  );
};

export default BannerImageContent;
